// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container{
    display: block;
    margin: auto;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.5);
    max-width: 100%!important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Bank.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;AAC7B","sourcesContent":[".form-container{\n    display: block;\n    margin: auto;\n    width: 100%;\n    padding: 20px;\n    box-sizing: border-box;\n    border-radius: 10px;\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.5);\n    max-width: 100%!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
